module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Կոմիտաս-Կաքավիկ.de602c6f.mp3";